// The CTA for a 'template' reward, shared by the referee modal and the referrer-side
// surfaces that render rewards through ReferralRewardDetail.
//
// A plain <a href>: react-router's <Link> resolves relative to this app and won't navigate
// to an external template_url.
export default function TemplateRewardLink({ reward }) {
  const url = reward?.payload?.template_url;
  if (!url) return null;
  return (
    <a
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className='mt-3 block w-full px-3 py-2 font-semibold text-white rounded-md hover:bg-emerald-500 bg-emerald-600 text-center'>
      <span>View templates</span>
    </a>
  );
}
